/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Filter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Filter"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M16 2.5c1.864 0 3.43 1.346 3.874 3.167H21c.552 0 1 .472 1 1.055s-.448 1.056-1 1.056h-1.126c-.444 1.82-2.01 3.166-3.874 3.166S12.57 9.6 12.126 7.778H3c-.552 0-1-.473-1-1.056s.448-1.055 1-1.055h9.126C12.57 3.846 14.136 2.5 16 2.5m0 6.333c1.105 0 2-.945 2-2.11 0-1.167-.895-2.112-2-2.112s-2 .945-2 2.111.895 2.111 2 2.111M2 17.278c0 .583.448 1.055 1 1.055h1.126C4.57 20.154 6.136 21.5 8 21.5s3.43-1.346 3.874-3.167H21c.552 0 1-.472 1-1.055s-.448-1.056-1-1.056h-9.126c-.444-1.82-2.01-3.166-3.874-3.166S4.57 14.4 4.126 16.222H3c-.552 0-1 .473-1 1.056m8 0c0-1.166-.895-2.111-2-2.111s-2 .945-2 2.11c0 1.167.895 2.112 2 2.112s2-.945 2-2.111"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const FilterIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'filter-icon'}
      icon={Filter}
      {...props}
      size={size}
    />
  );
};
